import trapFocus from '../utils/trapFocus';

export default function () {
  const hamburger = document.querySelectorAll('[data-hamburger]');
  const menu = document.querySelector('[data-menu]');
  const menuClose = document.querySelector('[data-menu-close]');

  hamburger.forEach((item) => {
    item.addEventListener('click', () => {
      menu.classList.add('menu--open');
      document.querySelector('body').classList.add('menu-open');
    });
  });

  menuClose.addEventListener('click', () => {
    menu.classList.remove('menu--open');
    document.querySelector('body').classList.remove('menu-open');
  });

  trapFocus(menu);
}
